import { Table,DatePicker } from 'antd'
import React from 'react'
import moment from 'moment';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';

export default function MonthlyProducedReport() {

  // const localizer = momentLocalizer(moment);

  const tableData=[{name:'item1',quantity:1000},{name:'item',quantity:1000},{name:'item',quantity:1000},{name:'item',quantity:1000}
,{name:'item',quantity:1000},{name:'item',quantity:1000}]
const cols=[{title:'Name',dataIndex:'name',key:'name'},{title:'Quantity',dataIndex:'quantity',key:'quantity'}]
  return (
    <div style={{textAlign:'center',justifyContent:'center'}}>
      <div style={{textAlign:'center',justifyContent:'center',display:'flex',marginTop:'20px',color:'#121f2e',fontSize:'60px',fontWeight:'bold'}}>Monthly Produced Report</div>
      <div style={{textAlign:'left',justifyContent:'center',display:'flex',marginTop:'20px',}}>
      <DatePicker onChange={()=>{return }} picker="month" placeholder='select month and year' style={{width:'400px'}} />
      </div>
      <div style={{textAlign:'center',justifyContent:'space-around',display:'flex',marginTop:'20px'}}>
     
      <div style={{textAlign:'center',justifyContent:'center',display:'flex',marginTop:'20px',flexBasis:'24%',height:'400px'}}>
        <Table dataSource={tableData} columns={cols}/>
      </div>
      <div style={{textAlign:'center',justifyContent:'center',display:'flex',marginTop:'20px',flexBasis:'24%',height:'400px'}}>
         {/* <Calendar
                style={{ height: '600px', }}
                localizer={localizer}
               
                defaultView={Views.MONTH}
        
            /> */}
      </div>
      <div style={{textAlign:'center',justifyContent:'center',display:'flex',marginTop:'20px',flexBasis:'24%',height:'400px'}}>
      <Table dataSource={tableData} columns={cols}/>
      </div>
      <div style={{textAlign:'center',justifyContent:'center',display:'flex',marginTop:'20px',flexBasis:'24%',height:'400px'}}>
      <Table dataSource={tableData} columns={cols}/>
      </div>

      </div>
    </div>
  )
}
